import __vue_component__ from './IssueRenderer.vue.js';

//
var script = {
  name: 'LinkedIssuesList',
  components: {
    IssueRenderer: __vue_component__
  },
  props: {
    issues: {
      type: Array,
      default: () => []
    },
    baseUrl: {
      type: String,
      default: ''
    },
    appearance: {
      type: String,
      default: 'normal',
      validator: value => ['normal', 'compact', 'micro'].includes(value)
    }
  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/field-renderers/LinkedIssuesList.vue_rollup-plugin-vue=script.js